module.exports = __webpack_public_path__ + "static/chop-lines-click-f4ebc997b35cec426e76ab16f3a038fa.gif";